import React from "react";
import {FormattedMessage} from "react-intl";
import {StopStatusInfo} from "../StopStatusInfo";
import {PudoStorage, StopKind, StopStatus} from "../model/rideInfo";
import deliveredIcon from "../image/status_delivered.svg";
import deliveringIcon from "../image/status_delivering.svg";
import scheduledIcon from "../image/status_scheduled.svg";
import undeliveredIcon from "../image/status_undelivered.svg";
import {ReactComponent as VerificationCodeIcon} from "../image/verification-code-icon.svg";

interface StopProps {
    status: StopStatus;
    kind: StopKind;
    name?: string;
    placeName?: string;
    verificationCode?: string;
    eta?: string;
    pudo?: PudoStorage;
}

function getStatusIcon(status: StopStatus) {
    //TODO: svgs not optimized for dark mode
    switch (status) {
        case "DELIVERING":
        case "REDIRECTED":
        case "ARRIVED":
            return deliveringIcon;
        case "IN_QUEUE":
            return scheduledIcon;
        case "UNDELIVERED":
        case "CANCELLED":
            return undeliveredIcon;
        case "DELIVERED":
        case "DELIVERED_TO_PUDO":
            return deliveredIcon;
        default:
            return scheduledIcon;
    }
}

function formatLabel(kind: StopKind, status: StopStatus) {
    if (status === "CANCELLED") {
        return (
            <span style={{color: "var(--text-error-secondary)"}}>
                <FormattedMessage id="courier_cancelled" />
            </span>
        );
    }
    switch (kind) {
        case "PICKUP":
            switch (status) {
                case "DELIVERED":
                    return <FormattedMessage id="picked_up" />;
                default:
                    return <FormattedMessage id="pickup" />;
            }
        case "DROP_OFF":
            switch (status) {
                case "UNDELIVERED":
                    return (
                        <span style={{color: "var(--text-error-secondary)"}}>
                            <FormattedMessage id="undelivered" />
                        </span>
                    );
                case "DELIVERED":
                    return <FormattedMessage id="delivered" />;
                default:
                    return <FormattedMessage id="delivery_drop_off" />;
            }
        case "RETURN":
            switch (status) {
                case "UNDELIVERED":
                    return (
                        <span style={{color: "var(--text-error-secondary)"}}>
                            <FormattedMessage id="undelivered" />
                        </span>
                    );
                case "DELIVERED":
                    return <FormattedMessage id="returned" />;
                default:
                    return <FormattedMessage id="return" />;
            }
        case "PUDO":
            switch (status) {
                case "REDIRECTED":
                    return <FormattedMessage id="redirected" />;
                case "DELIVERED_TO_PUDO":
                    return <FormattedMessage id="delivered_to_pudo" />;
            }
    }
}

export function Stop({status, kind, name, verificationCode, placeName, eta, pudo}: StopProps) {
    return (
        <div className="stop-row" data-cy="tracking-stop-row">
            <img
                height="16"
                width="16"
                alt=""
                src={getStatusIcon(status)}
                data-cy={`status-icon-${status.toLowerCase()}`}
            />
            <div className="detail" data-cy="tracking-detail">
                <div className="title" data-cy="tracking-title">
                    {name != null && name}
                    {verificationCode != null && (
                        <span className="verification-code" data-cy="tracking-verification-code">
                            <VerificationCodeIcon />
                            <span>{verificationCode}</span>
                        </span>
                    )}
                </div>
                <div className="subtitle" data-cy="tracking-subtitle">
                    {placeName != null && placeName}
                </div>
            </div>
            <div className="status" data-cy="tracking-status">
                <div className="label" data-cy="tracking-status-label">
                    {formatLabel(kind, status)}
                </div>
                <div className="arrival" data-cy="tracking-status-arrival">
                    {status === "ARRIVED" ? (
                        <FormattedMessage id="arrived" />
                    ) : (
                        eta != null && <StopStatusInfo eta={eta} />
                    )}
                </div>
            </div>
        </div>
    );
}
